
        var result = require("!!../../../../node_modules/css-loader/index.js!./user.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./app/components/user/user.component.css
// module id = 1437
// module chunks = 0